{
    "Accessibility menu": "Pieejamības izvēlne",
    "Close": "Aizvērt",
    "Content adjustments": "Satura pielāgojumi",
    "Navigation adjustments": "Navigācijas pielāgojumi",
    "Text Align": "Text Align",
    "Align Left": "Izlīdzināt pa kreisi",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Pielāgot fonta izmēru",
    "Highlight Title": "Izcelt virsrakstu",
    "Highlight Links": "Izcelt saites",
    "Readable Font": "Lasāms fonts",
    "Colour adjustments": "Krāsu pielāgojumi",
    "Dark Contrast": "Tumšs kontrasts",
    "Light Contrast": "Gaišs kontrasts",
    "High Contrast": "Augsts kontrasts",
    "High Saturation": "Augsts piesātinājums",
    "Low Saturation": "Zems piesātinājums",
    "Monochrome": "Vienkrāsains",
    "Tools": "Rīki",
    "Reading Guide": "Lasīšanas vadīkla",
    "Big Cursor": "Liels kursors",
    "Increase Font Size": "Palielināt fonta izmēru",
    "Decrease Font Size": "Samazināt fonta izmēru",
    "Letter Spacing": "Burtu atstarpes",
    "Line Height": "Rindas augstums",
    "Font Weight": "Fonta biezums",
    "Dyslexia Font": "Fonts disleksijai",
    "Language": "Valoda",
    "Accessibility widget": "Pieejamības logrīks",
    "Accessibility Profiles": "Pieejamības profili",
    "Cognitive Disability": "Kognitīvie traucējumi",
    "Seizure Safe": "Drošs pret lēkmēm",
    "Accessibility statement": "Pieejamības paziņojums",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Apturēt animācijas",
    "Animation paused": "Animācija apturēta",
    "Reset all settings": "Atiestatīt iestatījumus",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
